"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrashIcon = TrashIcon;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TrashIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_7168_64149)"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 0.00012207C4.44772 0.00012207 4 0.447837 4 1.00012L4 3.00012L1 3.00012L1 5.00012L15 5.00012V3.00012L12 3.00012V1.00012C12 0.447837 11.5523 0.00012207 11 0.00012207L5 0.00012207ZM10 2.00012L6 2.00012L6 3.00012L10 3.00012V2.00012Z",
      fill: "#0661EC"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7.00012L13 7.00012V13.0001C13 14.1047 12.1046 15.0001 11 15.0001L5 15.0001C3.89543 15.0001 3 14.1047 3 13.0001L3 7.00012Z",
      fill: "#0661EC"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_7168_64149"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "16",
      height: "16",
      fill: "white"
    }))))
  );
}